import { render, staticRenderFns } from "./BabyPhoto.vue?vue&type=template&id=2e1e63de&scoped=true&"
import script from "./BabyPhoto.vue?vue&type=script&lang=js&"
export * from "./BabyPhoto.vue?vue&type=script&lang=js&"
import style0 from "./BabyPhoto.vue?vue&type=style&index=0&id=2e1e63de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1e63de",
  null
  
)

export default component.exports